<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">
            {{ "PurchaseEdit.summary" | translate }}
        </h5>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseEdit.removedSessions" | translate }}
                </div>
                <div class="col-sm-10">
                    {{ summary.valueOfRemovedSessions | amount }}
                </div>
            </div>

            <!-- <div class="row">
      <div class="col-sm-2 bolded">{{'PurchaseEdit.addedSessions' | translate}}</div>
      <div class="col-sm-10">{{summary.valueOfAddedSessions| amount}}</div>
    </div> -->

            @if (summary.paymentMethodValueChange) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.creditCardFeeChange" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ summary.paymentMethodValueChange | amount }}
                    </div>
                </div>
            }

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseEdit.cancelationFee" | translate }}
                </div>
                <div class="col-sm-10">
                    <span>{{ summary.adjustedCancellationFee | amount }} </span>
                    <span class="ml-1">
                        <i
                            class="fa fa-info-circle"
                            placement="right"
                            aria-hidden="true"
                            [tooltip]="cancellationTooltip"
                        ></i>
                    </span>
                    @if (summary.adjustedCancellationFee > 0) {
                        <a
                            class="ml-1"
                            href="javascript:void(0)"
                            (click)="waiveCancellation()"
                            >{{ "PurchaseEdit.waive" | translate }}</a
                        >
                    }
                </div>
                <ng-template #cancellationTooltip
                    >{{ "PurchaseEdit.cancellationFeeExplanation" | translate }}
                </ng-template>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseEdit.discountChange" | translate }}
                </div>
                <div class="col-sm-10">
                    {{ summary.discountValueChanges | amount }}
                    <!-- <a class="ml-1" href="javascript:void(0)" (click)="waiveDiscounts()">{{'PurchaseEdit.waive' | translate}}</a> -->
                </div>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseEdit.creditDaysChange" | translate }}
                </div>
                <div class="col-sm-10">
                    {{ summary.creditPointsValueChange | amount }}
                    <span class="ml-1"
                        >({{ summary.creditDaysNumberChange }}
                        <span class="ml-1"
                            >{{ "PurchaseEdit.days" | translate }})</span
                        >
                    </span>
                </div>
            </div>
            <div class="row">
                <hr class="w-25 ml-1" />
            </div>

            @if (summary.valueToBePaidOrReturned > 0) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.amountToBeReturned" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ summary.valueToBePaidOrReturned | amount }}
                    </div>
                </div>
            }
            @if (summary.creditDaysNumberChange > 0) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.creditDaysToBeReturned" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ summary.creditDaysNumberChange
                        }}<span class="ml-1">{{
                            "PurchaseEdit.days" | translate
                        }}</span>
                    </div>
                </div>
            }

            @if (summary.originalTender) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.refundTo" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{
                            translatePaymentMethod(
                                summary.originalTender?.paymentMethod
                            )
                        }}
                        @if (appendWeeksRefundInfo) {
                            <span>{{
                                "PurchaseEdit.creditDaysRefund" | translate
                            }}</span>
                        }
                    </div>
                </div>
            }

            @if (
                summary.originalTender &&
                summary.originalTender.creditCardNumber
            ) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.cardNumber" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ summary.originalTender.creditCardNumber }}
                    </div>
                </div>
            }

            @if (
                summary.originalTender &&
                summary.originalTender.creditCardHolder
            ) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseEdit.cardHolder" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ summary.originalTender.creditCardHolder }}
                    </div>
                </div>
            }
        </div>
    </div>
</div>
